import * as React from 'react';

import { createIcon } from '../Icon';

const shape = {
  points: '22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3',
};

export const FilterIcon = createIcon(<polygon points={shape.points} />, 'FilterIcon');

export const filterIconSvg = `
  <svg
    aria-hidden="true"
    focusable="false"
    role="img"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    style="display: block; fill: none; height: 16px; stroke: currentColor; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2; width: 16px;"
  >
    <polygon points="${shape.points}" />
  </svg>
`;
